import { env } from "./EnvironmentConfig"

export const APP_NAME = "MijnPraktijk.nl"
export const ENVIRONMENT_NAME = env.ENVIRONMENT_NAME
export const API_BASE_URL = env.API_ENDPOINT_URL
export const WEBSOCKET_URL = env.WEBSOCKET_URL
export const USES_SUBDOMAIN = env.USES_SUBDOMAIN
export const PUBLIC_HOST = env.PUBLIC_HOST
export const SECURE_COOKIE = env.SECURE_COOKIE
export const IS_LOCAL = ENVIRONMENT_NAME === "local"
export const AUTO_CLOSE_NOTIFICATION_TIMEOUT = env.AUTO_CLOSE_NOTIFICATION_TIMEOUT || 10000 // 10 seconds

export const REQUEST_TIMEOUT = env.REQUEST_TIMEOUT || 10000 // 10 seconds
export const UPLOAD_TIMEOUT = env.UPLOAD_TIMEOUT || 20000 // 20 seconds

export const PORTAL_PREFIX_PATH = "/portal"
export const AUTH_PREFIX_PATH = "/auth"
export const CARE_GROUP_SLUG = "z"
export const CARE_GROUP_PREFIX_PATH = `/${CARE_GROUP_SLUG}`
export const PUBLIC_PREFIX_PATH = ""

export const VIDEO_MEETING_HOST = "meet.mijnpraktijk.nl"
